<template>
    <main>
        <header>
            <h1>お気に入り選手設定</h1>
        </header>
        <div class="regist selectClubs">
            <p class="aCt">
                お気に入り選手は3クラブまで登録できます。<br>
                1クラブあたり3名の選手を登録できます。
            </p>
    
            <input v-for="league in leagues" :key="league" type="radio" name="league" :id="'league' + league" :value="league" v-model="selectedLeague" class="hiddenTrig">
    
            <div class="leagueToggle">
                <ul class="selectLeague">
                    <li v-for="league in leagues" :key="league" :tabindex="0" @keydown.enter="selectLeague(league)">
                        <label :for="'league' + league" 
                                :class="{ active: selectedLeague === league, [league.toLowerCase()]: true }">{{ league }}</label>
                    </li>
                </ul>
                <ul v-for="league in leagues"
                    :class="['clubList', 'setting', league.toLowerCase()]">
                    <li v-for="club in getSpecifiedClubTeams(league)" :key="club.clubCode">
                        <div class="club-team">
                            <img :src="emblemImagePath(club.emblemImg)"
                                    :alt="club.teamName">{{ club.teamName }}
                            <label class="mail-setting" :tabindex="getTabIndex(league)" @keydown.enter="goToPlayerSelection(club.clubCode, $event)">
                                <input 
                                    v-model="selectedClubCodes"
                                    @click="goToPlayerSelection(club.clubCode, $event)"
                                    :value="club.clubCode"
                                    type="checkbox">
                                <b>
                                    <i class="fas fa-portrait"></i>
                                </b>
                            </label>
                        </div>
                    </li>
                </ul>
            </div>
    
            <!-- 「サービスに戻る」ボタン -->
            <div class="btnSpace">
                <a class="return js-back-to-service" href="/home" id="backButton">
                    <button type="button" class="return">
                        サービスに戻る
                    </button>
                </a>
            </div>
        </div>
    </main>
</template>

<script>
import { mixinJleague } from '../../mixin/utility'

export default {
    name: 'SelectClub',
    mixins: [mixinJleague],
    props: {
        favoritePlayerList: {
            type: Array,
            required: true
        },
        selectedClubCodes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            leagues: ['J1', 'J2', 'J3'],
            selectedLeague: 'J1'
        }
    },
    methods: {
        emblemImagePath(file) {
            return 'https://auth2.jleague.jp/emblem/' + file;
        },
        selectLeague(league) {
            this.selectedLeague = league;
        },
        getTabIndex(league) {
            return league === this.selectedLeague ? 0 : -1;
        },
        goToPlayerSelection(clubCode, event) {
            const isAlreadySelected = this.selectedClubCodes.includes(clubCode);
            if (this.selectedClubCodes.length <= 3 || isAlreadySelected) {
                if (!isAlreadySelected && this.selectedClubCodes.length >= 3) {
                    alert('登録できるクラブは3つまでです。');
                    event.preventDefault();
                    return;
                }
                this.$emit('club-selected', clubCode);
            }
        },
    },
    mounted() {
        // 「サービスに戻る」ボタンのリンクを動的に設定する処理
        let originalRedirectUri;
        const query = new URLSearchParams(location.search);
        const hash = location.hash;
        const params = new URLSearchParams(hash.slice(1));

        originalRedirectUri = params.get("original_redirect_uri");

        const backToServiceButtons = document.getElementsByClassName('js-back-to-service');
        Array.from(backToServiceButtons).forEach(function(element) {
            element.setAttribute('href', originalRedirectUri || '/home');
        });

        const target = document.getElementById('backButton');
        if (target) {
            query.set('sid', '3007');
            target.href = `${target.href.split('?')[0]}?${query.toString()}`;
        }
    }
}
</script>
